export default __webpack_public_path__ + "static/media/icons-enroll-2-32-px.66b5c591.svg";